import { render, staticRenderFns } from "./BusinessCreatePage.vue?vue&type=template&id=5fb9c79d&scoped=true&"
import script from "./BusinessCreatePage.vue?vue&type=script&lang=js&"
export * from "./BusinessCreatePage.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCreatePage.vue?vue&type=style&index=0&id=5fb9c79d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb9c79d",
  null
  
)

export default component.exports